import styled from 'styled-components';

export const BannerPromo = styled.div`
  color: #fff;
  min-height: 220px;
  margin: 50px 0 0;

  @media (max-width: 767.98px) {
    margin: 30px 0 0;
  }

  img {
    transition: 0.5s;

    @media (min-width: 1280px) {
      height: auto;
      width: 100%;
    }

    @media (max-width: 1279px) {
      height: 100%;
      width: auto;
    }
  }

  .banner-cta {
    justify-content: flex-end;
    display: flex;

    div {
      display: flex;
      flex-flow: column;
      justify-content: center;
      padding: 0 0.5rem;

      &:first-child {
        padding-left: 0;
        padding-right: 0;
        @media (max-width: 767px) {
          padding-bottom: 10px;
        }
      }
    }

    @media (max-width: 767px) {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;

export const PromoContainer = styled.div`
  position: relative;
  background-color: #d8dee2;
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: 100%;
  height: 220px;
  padding: 0 80px;

  @media (max-width: 575.98px) {
    height: 300px;
    padding: 0 25px;
  }

  &:hover {
    img {
      transform: scale(1.1);
    }
  }
`;

export const BannerImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  span {
    @media (max-width: 767.98px) {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
    }
    @media (max-width: 575.98px) {
      height: 100%;
    }

    &.lazy-load-image-background {
      display: block !important;
      height: 100%;

      img {
        transition: 0.5s !important;
      }
    }
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }

  div {
    height: 100%;
  }
`;

export const BannerContent = styled.div`
  &.content {
    display: flex;
    justify-content: space-between;

    &[dir='ltr'] {
      .caption {
        padding-right: 50px;
        p {
          letter-spacing: 1.29px;
        }
        @media (max-width: 991.98px) {
          padding: 0px;
        }
      }
    }

    &[dir='rtl'] {
      .caption {
        padding-left: 50px;
      }
    }

    .caption {
      max-width: 600px;

      h2 {
        margin-bottom: 0;
        font-family: ${({ dir }) => (dir === 'rtl' ? 'GEAwtarDWTCMedium,serif' : '')};

        @media (min-width: 1200px) {
          line-height: 40px;
          width: ${({ dir }) => (dir === 'rtl' ? '80%' : '')};
        }

        @media (max-width: 767px) {
          text-align: center;
          margin-bottom: 1.5rem;
          font-size: 20px;
          line-height: 30px;
        }
      }

      p {
        color: #fff;
        text-transform: uppercase;
        margin: 10px 0 0;

        @media (max-width: 991px) {
          margin: 1rem 0;
        }

        @media (max-width: 767px) {
          display: none;
        }
      }
    }

    @media (max-width: 991px) {
      flex-wrap: wrap;
      justify-content: center;

      .caption {
        text-align: center;
        width: 100%;
        padding: 0 !important;
      }
    }
  }
`;

export const BannerPromoStaticImage = styled.img`
  object-fit: cover;
  height: 100%;
`;
